module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"upgrade":"Oppgrader nå","paymentLabel":"Manglende betaling"},"en":{"upgrade":"Upgrade now","paymentLabel":"Missing payments"}}')
  delete Component.options._Ctor
}
